//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconMiscAgent(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}><path d="M16.707 16.707L15.4141 18H8.30664L8.00586 17.6201L7.21582 16.6201L8.78418 15.3799L9.27441 16H14.5859L15.293 15.293L16.707 16.707Z" fill="currentColor" /><path d="M9.5 11C10.3284 11 11 11.6716 11 12.5C11 13.3284 10.3284 14 9.5 14C8.67157 14 8 13.3284 8 12.5C8 11.6716 8.67157 11 9.5 11Z" fill="currentColor" /><path d="M14.5 11C15.3284 11 16 11.6716 16 12.5C16 13.3284 15.3284 14 14.5 14C13.6716 14 13 13.3284 13 12.5C13 11.6716 13.6716 11 14.5 11Z" fill="currentColor" /><path fillRule="evenodd" clipRule="evenodd" d="M14 5H13V7H20V11H22V18H20V22H4V18H2V11H4V7H11V5H10V2H14V5ZM6 20H18V9H6V20Z" fill="currentColor" /></svg>;
}
export default IconMiscAgent;